import gql from "graphql-tag";

export const getSearchPersonQuery = gql`
  query getSearchPerson ($searchText: String!) {
    searchPerson (searchText: $searchText) {
      personId
      fullName
    }
  }
`;